"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MapmarkerFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function MapmarkerFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "mapmarker-fill",
    d: "M50,10A26.606,26.606,0,0,0,26.079,48.35v.07l.275.5c.163.312.332.618.506.923L48.545,89.4a2.064,2.064,0,0,0,2.91,0L73.14,49.845c.174-.3.343-.611.5-.923l.276-.5v-.07A26.606,26.606,0,0,0,50,10Zm0,37.037a9.7,9.7,0,1,1,9.7-9.7A9.7,9.7,0,0,1,50,47.037Z"
  })));
}